export default __webpack_public_path__ + "static/Averta-Semibold-293a6df1ba429de0b36ba121bb9829f4.woff";